
<style scoped>
.state-back {
  width: 84px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #C0C0C0;
  position: absolute;
  left: 0;
  top: 0
}
.sum-statis {
  padding: 10px 0 0 20px;
  background: #fff;
  text-align: left;
}

.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.detail-row {
  display: flex;
  padding: 0 20px;
}

.detail-row .item {
  display: flex;
  flex: 1;
  align-items: center;
}

.detail-row .item .tittle {
  width: 110px;
  text-align: left;
}

.detail-row .item .content {
  width: 500px;
  text-align: left;
}

.detail-row .pdf-container img {
  width: 40px;
  height: 40px;
}

.detail-row .item .pdf-container {
  width: auto;
  text-align: center;
}

/deep/ .el-upload-list {
  text-align: left;
  max-height: 150px;
  overflow-y: auto;
}

.back-title {
  text-align: center;
  position: relative;
  padding-bottom: 16px;
  margin-bottom:25px;
  height: 30px
}

.back {
  position: absolute;
  left: 16px
}

.title {
  font-size: 16px;
  font-weight: bold;
  padding-top: 4px;
}
</style>
<style >
.freelist .el-form-item__content {
  margin-left: 0 !important;
}

.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}

.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}

.freelist .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

.freelist .el-image {
  visibility: hidden;
}

.freelist .file1 .el-upload--picture-card {
  display: none;
}

.el-image-viewer__wrapper {
  z-index: 99999 !important;
}
.el-drawer__body {
        overflow: auto;
    }
    .search-area{
      margin:2px 0;
    }
</style>
<template>
  <div class="content freelist">
    <Title :currentPageTitle="parentDetail.tenantName+'-'+getFreeName(parentDetail, 1)"></Title>
    <div class="search-area" style="">
      <el-row :gutter="24">
        <el-col :span="8">
          <div class="search-area-div">部门名称：</div>
          <el-select v-model="page.organisationGuid" placeholder="请选择部门名称" filterable class="ipt-sty">
            <el-option v-for="item in organisationList" :key="item.guid" :label="item.organisationName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">人员姓名：</div>
          <el-input v-model="page.staffName" class="ipt-sty" placeholder="请输入人员姓名"></el-input>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">手机号码：</div>
          <el-input v-model="page.mobileNo" class="ipt-sty" placeholder="请输入手机号"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15">
        <el-col :span="8">
          <div class="search-area-div">发送状态：</div>
          <el-select v-model="page.sendState" placeholder="请选择发送状态" filterable class="ipt-sty">
            <el-option v-for="item in sendList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
    
        <el-col :span="8">
          <div class="search-area-div">查看状态：</div>
          <el-select v-model="page.viewState" placeholder="请选择查看状态" filterable class="ipt-sty">
            <el-option v-for="item in seeStateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <div style="text-align: left">
            <el-button size="medium" type="info" @click="search">搜索</el-button>
            <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
          </div>
        </el-col>
      </el-row>
     
    </div>

    <div class="button-area">
      <el-button size="medium" type="info" @click="sendSalary('')">批量发送</el-button>
      <el-button size="medium" type="info" @click="backSalary('')">批量撤回</el-button>
      <el-button size="medium" type="info" @click="exportSalary">导出工资条</el-button>
      <el-button size="medium" type="info" @click="addSalary">新增工资条</el-button>
    </div>
    <div class="sum-statis">合计：已发送 {{ summary.sendCount }} 人，已撤回 {{ summary.backCount }} 人 ，已查看（排除撤回的） {{ summary.viewCount }}
      人，未查看 {{ summary.sendCount - summary.viewCount }} 人</div>
    <div class="back-color-fff p16">
      <el-table @selection-change="handleSelectionChange" :data="tableData" border style="width: 100%">
        <el-table-column type="selection" v-if="tableData&&tableData.length != 0"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="staffName" label="员工姓名" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.staffName }}</template>
        </el-table-column>

        <el-table-column prop="mobileNo" label="手机号" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.mobileNo }}</template>
        </el-table-column>

        <el-table-column prop="accountMonth" label="员工状态" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.bizState == 'Y' ? '在职' : '离职' }}</template>
        </el-table-column>


        <el-table-column prop="organisationName" label="部门名称" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
        </el-table-column>

        <el-table-column prop="organisationName" label="发送状态" header-align="center" align="center">
          <template slot-scope="scope">{{
              scope.row.sendState == 'Y' ? '已发送' : scope.row.sendState == 'R' ? '已撤回' : '待发送'
          }}</template>
        </el-table-column>

        <el-table-column prop="organisationName" label="查看状态" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.viewState == 'Y' ? '已查看' : '未查看' }}</template>
        </el-table-column>
        <el-table-column prop="inputTime" label="发送时间" header-align="center" align="center" width="180">
          <template slot-scope="scope">
          <div  v-if="!scope.row.sendTime">
             -
          </div>
          <div v-else>{{ scope.row.sendTime | getTime }}</div>

          </template>
          <!-- <template slot-scope="scope" v-else>{{ scope.row.sendTime | getTime }}</template> -->
        </el-table-column>

        <el-table-column label="操作" header-align="center" align="center" width="220">
          <template slot-scope="scope">
            <!-- 待发送 显示发送按钮-->
            <a class="txt-color" v-if="scope.row.sendState == 'S'" @click="sendSalary(scope.row)">发送 | </a>
            <!-- 已撤回 显示重新发送按钮 -->
            <a class="txt-color" v-if="scope.row.sendState == 'R'" @click="sendSalary(scope.row)">重新发送 | </a>
            <!-- 已发送&&未查看 显示撤回按钮 -->
            <a class="txt-color" v-if="scope.row.viewState == 'N' && scope.row.sendState == 'Y'"
              @click="backSalary(scope.row)">撤回 | </a>

            <a class="txt-color" 
              @click="editSalary(scope.row)">编辑 | </a>
            <a class="txt-color" @click="seeSalary(scope.row)">详情</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>

    <el-drawer :title="salaryTitle" direction="rtl" :visible.sync="dialogVisible" size="40%">
      <el-form style="padding-left:20px;" label-width="160px" :label-position="right" class="demo-ruleForm">
        <el-form-item v-if="!isEdit">
          <span slot="label" style="color: red">*</span>
          <span slot="label">员工姓名：</span>
          <el-select @change="selectChanged" v-model="salaryForm.staffGuid" filterable placeholder="请选择人员" class="fl"
            style="width:60%;">
            <el-option v-for="(item, index) in staffList" :key="index" :label="item.staffName" :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-else>
          <span slot="label" style="color: red">*</span>
          <span slot="label">员工姓名：</span>
          <div class=" fl" style="text-align:left;width:60%; ">{{ salaryForm.staffName }}</div>
        </el-form-item>

        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">手机号：</span>
          <div class=" fl" style="text-align:left;width:60%; ">{{ salaryForm.mobileNo || '-' }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">身份证号：</span>
          <div v-if="disabled" class="fl" style="text-align:left;width:60%; ">{{ salaryForm.idCode || '-' }}</div>
          <el-input v-else class="fl" style="width:60%;" v-model.trim="salaryForm.idCode" placeholder="请输入">
          </el-input>
        </el-form-item>

        <el-form-item v-show="item.isShow" v-for="(item, index) in salaryForm.salaryInfo" :key="index">
          <span slot="label" style="color: white">*</span>
          <span slot="label">{{ item.name }}：</span>
          <div v-if="disabled" class="fl" style="text-align:left;width:60%; ">{{ item.value || '-' }}</div>
          <el-input v-else class="fl" style="width:60%;" v-model.trim="item.value" placeholder="请输入">
          </el-input>
        </el-form-item>

      </el-form>
      <div class="dialog-footer" style="padding-bottom:20px;">
        <el-button size="medium" @click="dialogVisible = false;">{{ !disabled ? '取 消' : '确 定' }}</el-button>
        <template v-if="!disabled">
          <el-button v-if="!isEdit" size="medium" type="info" @click="addReqVersion">确 定</el-button>
          <el-button v-else size="medium" type="info" @click="editReqVersion">修 改</el-button>
        </template>
      </div>
    </el-drawer>



  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import Title from '@/components/title/title.vue';
export default {
  components: {
    Title,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  data() {
    return {
      sendList: [
        { value: '', label: '全部' },
        { value: 'S', label: '待发送' },
        { value: 'Y', label: '已发送' },
        { value: 'R', label: '已撤回' },
      ],
      seeStateList: [
        { value: '', label: '全部' },
        { value: 'Y', label: '已查看' },
        { value: 'N', label: '未查看' },
      ],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        organisationGuid: null,
        sendState: null,
        viewState: null,
        mobileNo: null,
        parentGuid: null
      },
      staffList: [],
      tenantList: [],
      organisationList: [],
      errorInfoList: [],
      timeLists: '',
      srcLists: [],


      taskGuid: [],
      srcList: [],
      fullscreenLoading: false,
      textTitle: '新增完税凭证',
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      startEndTime: '',
      payMonth: '',
      payMoney: '',
      note: '',
      payFile: '',

      guid: '',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',

      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      filePdfAttachList: [],
      filePdfAttachListII: [],
      filePdfAttachListIII: [],
      showViewer: false,
      taskList: [],
      taskGroup: [],
      currentCompanyGuid: '',

      parentDetail: null,
      slectedSalaryList: [],
      summary: {
        detailCount: 0,
        sendCount: 0,
        viewCount: 0,
        backCount: 0,
      },
      salaryInfo: [],
      salaryTitle: '',
      isEdit: false,
      disabled: false,
      salaryForm: {
        staffName: '',
        staffGuid: '',
        parentGuid: '',
        guid: '',
        salaryInfo: [],
        mobileNo: '',
        idCode: ''

      }
    };
  },
  created() {
    this.parentDetail = JSON.parse(this.$route.query.detail);
    this.getOrganisationList(this.parentDetail.tenantGuid);
    this.getStaffList(this.parentDetail.tenantGuid);
    this.page.parentGuid = this.parentDetail.guid;
    this.getList();
    this.getSalarySummary();
  },
  watch: {
    payMonth(newVal) {
      if (!newVal) return;
      var newVal = newVal + '-01';
      var self = this;
      self.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?date=` +
          newVal +
          '&tenantGuid=' +
          this.currentCompanyGuid
        )
        .then((resp) => {
          self.startEndTime = resp.data.data.replace(',', '至');
        });
    }
  },
  methods: {
    seeSalary(row) {
      let colInfo = JSON.parse(this.parentDetail.colInfo);
      let salaryInfo = JSON.parse(row.salaryInfo);
      colInfo.forEach(i => {
        salaryInfo.forEach(j => {
          if (i.guid == j.guid) {
            i.value = j.value;
          }
        })
      })
      this.salaryForm = {
        staffName: row.staffName,
        staffGuid: row.staffGuid,
        parentGuid: row.parentGuid,
        guid: row.guid,
        salaryInfo: colInfo,
        mobileNo: row.mobileNo,
        idCode: row.idCode
      }
      this.salaryTitle = this.parentDetail.tenantName + '-' + this.getFreeName(this.parentDetail, 1)
      this.isEdit = true;
      this.disabled = true;
      this.dialogVisible = true;
    },
    //修改工资条
    editSalary(row) {
      let colInfo = JSON.parse(this.parentDetail.colInfo);
      let salaryInfo = JSON.parse(row.salaryInfo);
      colInfo.forEach(i => {
        salaryInfo.forEach(j => {
          if (i.guid == j.guid) {
            i.value = j.value;
          }
        })
      })
      this.salaryForm = {
        staffName: row.staffName,
        staffGuid: row.staffGuid,
        parentGuid: row.parentGuid,
        guid: row.guid,
        salaryInfo: colInfo,
        mobileNo: row.mobileNo,
        idCode: row.idCode
      }
      this.salaryTitle = this.parentDetail.tenantName + '-' + this.getFreeName(this.parentDetail, 1)
      this.isEdit = true;
      this.disabled = false;
      this.dialogVisible = true;
    },
    addSalary() {
      this.salaryTitle = this.parentDetail.tenantName + '-' + this.getFreeName(this.parentDetail, 1)
      let colInfo = JSON.parse(this.parentDetail.colInfo);
      this.salaryForm = {
        staffName: '',
        staffGuid: '',
        parentGuid: this.parentDetail.guid,
        salaryInfo: colInfo,
        mobileNo: '',
        idCode: '',
        realSalary: ''
      }
      this.isEdit = false;
      this.disabled = false;
      this.dialogVisible = true;
    },
    selectChanged() {
      let staffGuid = this.salaryForm.staffGuid;
      console.log(staffGuid)
      this.staffList.forEach(item => {
        if (item.guid == staffGuid) {
          this.salaryForm.idCode = item.idCode;
          this.salaryForm.staffName = item.staffName;
          this.salaryForm.mobileNo = item.mobileNo
        }

      })
      console.log(this.salaryForm)
    },
    exportSalary() {
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/export-detail?guid=${this.parentDetail.guid}`).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
    },
    //获取汇总信息
    getSalarySummary() {
      var self = this;
      if (self.timeLists != null && self.timeLists.length > 0) {
        self.page.startTime = self.$moment(self.timeLists[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.endTime = self.$moment(self.timeLists[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        self.page.startTime = '';
        self.page.endTime = '';
      }
      let req = {
        pageIndex: 1,
        pageSize:-1,
        organisationGuid: this.page.organisationGuid,
        sendState: this.page.sendState,
        viewState: this.page.viewState,
        mobileNo:  this.page.mobileNo,
        parentGuid:  this.page.parentGuid,
        startTime: this.page.startTime,
        endTime: this.page.endTime
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/get-list-detail-total`, self.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          this.summary = {
            detailCount: data.detailCount,
            sendCount: data.sendCount,
            viewCount: data.viewCount,
            backCount: data.backCount,
          }
          console.log(this.summary)
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(v) {
      console.log(v);
      this.slectedSalaryList = v;
    },
    //发送工资
    sendSalary(detail) {
      let req = null;
      if (detail) {
        req = {
          guid: detail.guid,
          parentGuid: detail.parentGuid,
          sendState: 'Y'
        }
      } else {
        if (this.slectedSalaryList.length == 0) {
          this.$message.error('请选择要发送的工资条');
          return;
        }

        let guidList = [];
        try {
          this.slectedSalaryList.forEach(item => {
            if (item.sendState == 'Y') {
              throw new Error('批量发送的工资条有被已发送的记录，请检查！');
            }
            guidList.push(item.guid)
          })
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        req = {
          guidList,
          sendState: 'Y'
        }
      }
      this.$confirm('发送后，员工可以收到工资条啦，确定这样操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.tableLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/update-detail`, req).then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('已发送');
            this.getList();
            this.getSalarySummary();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }).catch(() => { })
    },
    //撤回工资
    backSalary(detail) {
      let req = null;
      if (detail) {
        req = {
          guid: detail.guid,
          parentGuid: detail.parentGuid,
          sendState: 'R'
        }
      } else {
        if (this.slectedSalaryList.length == 0) {
          this.$message.error('请选择撤回的工资条');
          return;
        }
        let guidList = [];
        try {
          this.slectedSalaryList.forEach(item => {
            if (item.viewState == 'Y') {
              throw new Error('已被查看的记录无法撤回，请检查！');
            }
            guidList.push(item.guid)
          })
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        req = {
          guidList,
          sendState: 'R'
        }
      }
      this.$confirm('撤回后，员工将无法查看到工资条，确定这样操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.tableLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/update-detail`, req).then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('已撤回');
            this.getList();
            this.getSalarySummary();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }).catch(() => { })

    },
    getFreeName(detail, type) {
      if (!detail.accountMonth) return;
      let month = detail.accountMonth.substr(0, 4) + '年' + detail.accountMonth.substr(4, 5) + '月';
      let title = detail.title;
      let salaryName = this.getSalaryName(detail.salaryType);
      if (type) {
        return month + salaryName + title;
      } else {
        return month + salaryName;
      }

    },
    getSalaryName(salaryType) {
      if (salaryType == 1) {
        return '工资条'
      }
      if (salaryType == 2) {
        return '业务费用'
      }
      if (salaryType == 3) {
        return '其他'
      }
    },
    preview(srcList) {
      this.srcLists = [];
      // var srcList = JSON.parse(srcList);
      srcList.forEach((item) => {
        this.srcLists.push(item.path);
      });
      this.$forceUpdate();
      this.showViewer = true;
      // setTimeout(()=>{
      //   this.$refs.preview.clickHandler()
      // },300)
    },
    getTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
          // self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
          // self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisationList(tenantGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: tenantGuid
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getStaffList(guid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: guid
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.staffList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        organisationGuid: null,
        sendState: null,
        viewState: null,
        mobileNo: null,
        parentGuid: this.parentDetail.guid
      };
      this.getList(true);
      this.getSalarySummary();
    },
    search(){
      this.getList(true);
      this.getSalarySummary();
    },
    getList(flg) {
      var self = this;
      if (flg) {
        self.page.pageIndex = 1;
        self.tableData = [];
      }
      if (self.timeLists != null && self.timeLists.length > 0) {
        self.page.startTime = self.$moment(self.timeLists[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.endTime = self.$moment(self.timeLists[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        self.page.startTime = '';
        self.page.endTime = '';
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/get-list-detail`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addReqVersion() {
      let salaryForm = this.salaryForm;
      let self = this;
      if (!salaryForm.staffGuid) {
        this.$message.error('请选择人员!');
        return;
      }
      if (!salaryForm.mobileNo) {
        this.$message.error('请填写手机号!');
        return;
      }
      if (!salaryForm.idCode) {
        this.$message.error('请填写身份证号!');
        return;
      }
      var req = {
        salaryInfo: JSON.stringify(salaryForm.salaryInfo),
        staffGuid: salaryForm.staffGuid,
        mobileNo: salaryForm.mobileNo,
        parentGuid: salaryForm.parentGuid,
        idCode:salaryForm.idCode
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/add-detail`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList(true);
          self.getSalarySummary();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    editReqVersion() {
      let salaryForm = this.salaryForm;
      let self = this;
      if (!salaryForm.staffGuid) {
        this.$message.error('请选择人员!');
        return;
      }
      if (!salaryForm.mobileNo) {
        this.$message.error('请填写手机号!');
        return;
      }
      if (!salaryForm.idCode) {
        this.$message.error('请填写身份证号!');
        return;
      }
      var req = {
        salaryInfo: JSON.stringify(salaryForm.salaryInfo),
        staffGuid: salaryForm.staffGuid,
        mobileNo: salaryForm.mobileNo,
        parentGuid: salaryForm.parentGuid,
        guid: salaryForm.guid,
        idCode:salaryForm.idCode
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/update-detail`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.page.pageIndex = 1;
          self.getList(true);
          self.getSalarySummary();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>